import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Login, HasTell } from "../../../fetchs";
import Snackbar from "@material-ui/core/Snackbar";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";

import "./login.styles.css";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function SignIn(props) {
  const [openState, setOpenState] = useState(false);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();
  const [user, setuser] = useState({ passWord: "", tell: "" });
  const { passWord, tell } = user;

  const handleChange = (name) => (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    event.persist();
    setuser((prevState) => ({ ...prevState, [name]: value }));
  };
  function handleSubmit(e) {
    e.preventDefault();

    var Data = {
      tell: e.target.tell.value,
      passWord: e.target.passWord.value,
    };

    if (tell == "" || passWord == "") {
      toast.error("لطفا نام کاربری یا رمز عبور را وارد کنید");
      setLoading(false);
    } else {
      setLoading(true);
      HasTell(e.target.tell.value)
        .then((response) => {
          setLoading(false);
          if (response.status !== 200) {
            toast.error("خطای چک کردن شماره تماس");
          } else if (response.status === 200) {
            return response.json();
          }
        })
        .then((responseJson) => {
          if (responseJson.has == true) {
            setLoading(true);

            Login(Data)
              .then((response) => {
                setLoading(false);
                if (response.status !== 200) {
                  toast.error("شما مجاز به ورود نیستید!!!");
                } else if (response.status === 200) {
                  return response.json();
                }
              })
              .then((responseJson) => {
                if (responseJson.userTypeName === "admin") {
                  // localStorage.setItem("apiKey", responseJson.token);
                  localStorage.setItem(
                    "userData",
                    JSON.stringify(responseJson)
                  );
                  localStorage.setItem("isLogedin", true);
                  props.history.push("/main");
                } else {
                  toast.error("شما مجاز به ورود نیستید!!!");
                }
              })
              .catch((error) => {
                setLoading(false);
                console.error(error);
              });
          } else {
            toast.error("شماره تماس شما در سیستم ثبت نشده است!!!");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
        });
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          ورود به پنل مدیریت
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="tell"
            label="شماره تماس "
            name="tell"
            autoFocus
            value={tell}
            onChange={handleChange("tell")}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="passWord"
            label="رمز عبور"
            type="passWord"
            id="passWord"
            value={passWord}
            onChange={handleChange("passWord")}
          />
          {/* <div className='text-right'>
            <FormControlLabel
              control={<Checkbox value='remember' color='primary' />}
              label='مرا به خاطر نگهدار'
            />
          </div> */}

          <div className={classes.wrapper}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={loading}
            >
              ورود
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
          <Grid container>
            <Grid item xs className="text-center">
              <Link to="/forgetpass" variant="body2">
                فراموشی رمز عبور
              </Link>
            </Grid>
            {/* <Grid item>
              <Link href='#' variant='body2'>
                {"حساب کاربری ندارید؟ ثبت نام کنید"}
              </Link>
            </Grid> */}
          </Grid>
        </form>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={3000}
        open={openState}
        ContentProps={{
          "aria-describedby": "message-id",
          class:
            "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
        }}
        message={
          <span id="message-id"> نام کاربری یا رمز عبور اشتباه است </span>
        }
        onClose={() => setOpenState(false)}
      />
    </Container>
  );
}

export default withRouter(SignIn);
